module.exports = __webpack_public_path__ + "img/3770d8c.jpg";